module.exports = __webpack_public_path__ + "media/images/top/ranking-sample06-de624ee7db64b5db7ffdb5ef3918d156.jpg";